import { Box, Button, Card, Center, Grid, PasswordInput, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import queryString from 'query-string';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../components/ErrorMessage';
import Metadata from '../components/Metadata';
import { Page } from '../constants/pageTitles';
import useFetch from '../helpers/useFetch';
import mainLogo from '../logo.png';

const ConfirmPage = () => {
  const navigate = useNavigate();
  const fetch = useFetch();
  const { confirmationToken } = useParams();
  const [password, setPassword] = useState();
  const [passwordConfirmation, setPasswordConfirmation] = useState();
  const [error, setError] = useState();
  const location = useLocation();
  const next = queryString.parse(location.search).next;

  const submitForm = (e) => {
    setError(undefined);
    e.preventDefault();
    fetch(`/api/admin/users/confirm`, {
      method: 'POST',
      body: JSON.stringify({ confirmationToken, password }),
    })
      .then(() => {
        navigate(next || '/');
      })
      .catch(setError);
  };

  return (
    <div>
      <Metadata title={`${Page['confirmPage']}`} />
      <Center pt={60} h="100%">
        <Card withBorder p="lg">
          <Box ta="center" mb="lg">
            <img src={mainLogo} alt="Releva" style={{ maxWidth: '100%', height: 'auto' }} />
          </Box>

          <Box component="form" ta="left" onSubmit={(e) => submitForm(e)}>
            <Text ta="center" mb="md">
              Welcome! Please choose a password to continue.
            </Text>
            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>Password</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                <PasswordInput
                  name="password"
                  placeholder="Your Password"
                  error={password !== undefined && password === '' ? 'password cannot be blank' : null}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Grid.Col>
            </Grid>
            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>Confirm password</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                <PasswordInput
                  name="passwordConfirmation"
                  placeholder="Your Password"
                  error={password !== passwordConfirmation ? 'passwords do not match' : null}
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                />
              </Grid.Col>
            </Grid>

            <ErrorMessage message={error?.message} />

            <Grid mb="md">
              <Grid.Col span={12}>
                <Button
                  fullWidth
                  size="lg"
                  type="submit"
                  disabled={!password || !passwordConfirmation || password !== passwordConfirmation}
                >
                  Get Started <IconChevronRight size={16} />
                </Button>
              </Grid.Col>
            </Grid>
          </Box>
        </Card>
      </Center>
    </div>
  );
};

export default ConfirmPage;
